import { configureStore } from '@reduxjs/toolkit'

/* Reducers */
import auth from './auth'
import token from './token'
import user from './user'
import data from './data'
import city from './city'
import favourites from './favourites'
import lang from './lang'

/* Actions */
import { actionData, actionFavourites } from './actions'

/* Session guard */
import { checkToken } from '../helpers/token'

const store = configureStore({
    reducer: {
        auth,
        token,
        user,
        data,
        city,
        favourites,
        lang
    }
})

/* Drop an expired/invalid token on startup so the header never shows a stale "authorized" state */
checkToken(store)

actionData(store)
actionFavourites(store)

export { store }
